import { render } from "./RoomCard.vue?vue&type=template&id=76061817&scoped=true"
import script from "./RoomCard.vue?vue&type=script&lang=js"
export * from "./RoomCard.vue?vue&type=script&lang=js"

import "./RoomCard.vue?vue&type=style&index=0&id=76061817&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76061817"]])

export default __exports__